import axios from 'axios'
import { ExtendedApiResponse } from '@/types/general/ResponseType'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

export type AppConfig = {
    passkeys?: {
        enabled?: boolean
        // eslint-disable-next-line camelcase
        login_enabled?: boolean
    }
    clients?: {
        // eslint-disable-next-line camelcase
        force_hide_phone_number?: boolean
    }
}

export const getSlimConfig = async () => {
    return await axios.get(`${API_BASE_URL}/api/admin/config/slim`, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    }) as ExtendedApiResponse<AppConfig>
}
